export const PART_STATUSES = {
  FINISHED: 'FINISHED',
  IN_PROGRESS: 'IN_PROGRESS',
  QUEUED: 'QUEUED',
} as const;

export const PROCESSING_CATEGORIES = {
  PROCESSING: 'processing',
  VIEWER_CREATION: 'viewerCreation',
  THUMBNAIL_CREATION: 'thumbnailCreation',
  GEOMETRIC_INDEXING: 'geometricIndexing',
  UPLOAD: 'upload',
  VECTORIZATION: 'vectorization',
} as const;

export const CODE_PROTECTED_STATE = {
  LOCKED: 'locked',
  UNLOCKED: 'unlocked',
} as const;

export const PART_FILE_UNITS = {
  MM: 'mm',
  IN: 'in',
} as const;
